module.exports = __webpack_public_path__ + "img/sucuk.ca312d4d.png";